import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { formatUrlWithLocale } from "@helpers/format-url-with-locale";

import { EXTERNAL_ROUTES } from "../../routes/routes.constant";

type RemoveAdsLinkProps = {
  id: string;
  additionalClassName?: string;
  translationID: string;
};
function RemoveAdsLink({
  id,
  additionalClassName = "",
  translationID,
}: RemoveAdsLinkProps) {
  const { formatMessage } = useIntl();
  const onClickHandler = () => {
    document.cookie = `eventCategory=${id}; path=/;`;
    window.sessionStorage.setItem("modalClosed", "true");
  };
  return (
    <a
      id={id}
      href={formatUrlWithLocale(EXTERNAL_ROUTES.removeAds)}
      onClick={onClickHandler}
      className={`btn btn-quinary btn-with-icon ${additionalClassName}`}
    >
      <img
        className='mr-1'
        src='/static/img/plus.svg'
        alt={formatMessage({
          id: "remove-ads",
        })}
        width='24'
        height='24'
      />
      <FormattedMessage id={translationID} />
      {window.reactApp.isBirthDay && (
        <span className='ml-1 text-yellow'> -40%</span>
      )}
    </a>
  );
}

export default RemoveAdsLink;
